// extracted by mini-css-extract-plugin
module.exports = {"AddressContainer":"Address_AddressContainer__1pOUq","RowGroup2":"Address_RowGroup2__2Qmqf","Col1":"Address_Col1__3Qwk-","Col2":"Address_Col2__7hCml"};